<template>
  <div>
    <svg
      version="1.1"
      viewBox="0 0 200 200"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="max-width:250px; min-width:250px; min-height:250px; margin-bottom: -30px"
    >
      <circle
        id="backgroundBar"
        r="75"
        cx="100"
        cy="100"
        fill="white"
        :stroke="lastScore !== null ? backColor : '#DDDDDD'"
        :stroke-width="backStroke"
        stroke-linecap="butt"
        stroke-dasharray="472"
        transform="rotate(140, 100,100)"
      />

      <defs>
        <linearGradient id="grad1" x1="10%" y1="-10%" x2="-70%" y2="100%">
          <stop offset="0%" style="stop-opacity:0.5; stop-color: white" />
          <stop
            offset="100%"
            :style="
              'stop-opacity:0.1; transition: stop-color ease-out 0.4s; stop-color:' +
                (score ? color : 'white')
            "
          />
        </linearGradient>
      </defs>

      <circle
        id="scoreBar"
        v-if="score.no_answer"
        r="75"
        cx="100"
        cy="100"
        fill="none"
        stroke-width="7"
        stroke-linecap="butt"
        stroke-dasharray="480"
        transform="rotate(90,100,100)"
        :style="
          lastScore !== null
            ? 'transition: stroke ease-out 0.4s;  stroke: #C4C8EB'
            : ' stroke: #C4C8EB'
        "
      />

      <circle
        id="scoreBar"
        v-if="score.skipped"
        r="75"
        cx="100"
        cy="100"
        fill="none"
        stroke-width="7"
        stroke-linecap="butt"
        :stroke-dasharray="percentSkipped"
        transform="rotate(90,100,100)"
        :style="
          lastScore !== null
            ? 'transition: stroke ease-out 0.4s;  stroke: #EDA008'
            : ' stroke: #EDA008'
        "
      />

      <circle
        id="scoreBar"
        v-if="score.answered"
        r="75"
        cx="100"
        cy="100"
        fill="none"
        stroke-width="7"
        stroke-linecap="butt"
        :stroke-dasharray="percentAnswered"
        transform="rotate(90,100,100)"
        :style="
          lastScore !== null
            ? 'transition: stroke ease-out 0.4s;  stroke: ' + color
            : ' stroke: ' + color
        "
      />

      <text
        id="scoreLabel"
        :x="100 + centerMS"
        y="105"
        :fill="score ? 'black' : color"
        text-anchor="middle"
        :style="
          'font-size: 45px; stroke: ' +
            backColor +
            '; stroke-width: ' +
            (score ? '0' : '0.5px')
        "
      >
        {{ score.answered + score.skipped }}
        <tspan v-if="showLabel ? 1 : 0">%</tspan>
      </text>

      <text
        id="label"
        x="100"
        y="125"
        v-if="score"
        fill="#707070"
        :opacity="showLabel ? 1 : 0"
        text-anchor="middle"
        transform="matrix(1 0 0 1 0 0)"
        style="transition: opacity 0.1s ease-out, transform 6s ease-out; font-size: 14px;"
      >
        {{ label1 }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Object,
      default: () => {},
    },
    label1: undefined,
    label2: undefined,
    label3: undefined,
    label4: undefined,
    label5: undefined,
  },

  data() {
    return {
      dasharray: '470, 20000',
      timer: 0,
      angle: 1,
      backColor: '#F6F7FD',
      centerMS: 0,
      speed: 1.5,
      white: 'white',
      loadingValue: 0,
      lastScore: this.score,
      currentScore: this.score,
      firstTime: true,
    }
  },
  computed: {
    value: function() {
      const fixed = this.loadingValue.toFixed(0) / 10
      return fixed > this.score ? this.score : fixed
    },
    color: function() {
      if (this.score === 0 || this.score === null) return '#F6F7FD'

      return this.score < 6 ? '#EB235E' : this.score < 8 ? '#EDA008' : '#23EBB0'
    },
    label: function() {
      const labels = [
        {
          score: 4.5,
          label: this.label1,
        },
        {
          score: 5.5,
          label: this.label2,
        },
        {
          score: 7.5,
          label: this.label3,
        },
        {
          score: 9.0,
          label: this.label4,
        },
        {
          score: 10.1,
          label: this.label5,
        },
      ]

      const item = Object.assign(
        { label: '' },
        labels.find(item => this.score < item.score)
      )

      return item.label
    },
    backStroke: function() {
      return this.lastScore ? 3 : 8
    },
    showLabel: function() {
      return this.score.answered || this.score.skipped || this.score.no_answer
    },
    percentAnswered: function() {
      return this.score.answered * 4.8 + ', 20000'
    },
    percentSkipped: function() {
      return this.score.answered * 4.8 + this.score.skipped * 4.8 + ', 20000'
    },
  },
  beforeUpdate: function() {
    this.updateOverall()
  },
  methods: {
    navigatorSupport: function() {
      const isOpera =
        (navigator.userAgent.indexOf('Opera') ||
          navigator.userAgent.indexOf('OPR')) !== -1
      const isChrome = navigator.userAgent.indexOf('Chrome') !== -1
      const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1
      const isIE =
        navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode
      const isEdge = !isIE && !!window.StyleMedia

      this.centerMS = isIE || isEdge ? 7 : 0 // centralizar label caso seja um browser da microsoft
      this.white =
        isOpera || isChrome || isFirefox || isIE || isEdge
          ? 'url(#grad1)'
          : 'white'

      const isIphone = navigator.userAgent.match(/iPhone/i)
      const isIpad = navigator.userAgent.match(/iPad/i)
      const isIpod = navigator.userAgent.match(/iPod/i)
      const isWinPhone = navigator.userAgent.match(/Windows Phone/i)
      const isAndroid = navigator.userAgent.match(/Android/i)
      const isWebOS = navigator.userAgent.match(/webOS/i)
      const isBlackBerry = navigator.userAgent.match(/BlackBerry/i)

      this.speed =
        isIphone ||
        isIpad ||
        isIpod ||
        isWinPhone ||
        isAndroid ||
        isWebOS ||
        isBlackBerry ||
        isIE ||
        isEdge
          ? 3
          : 1.5
    },
    changeAngule: function() {
      const setAngule = () => {
        this.backColor = '#DDDDDD'

        if (this.score) {
          this.backColor = '#707070'
          this.dasharray = this.angle + ', 20000'

          if (this.showLabel) clearInterval(this.timer)

          this.angle += this.speed

          this.loadingValue =
            this.score <= this.loadingValue
              ? this.loadingValue + 0.4
              : this.score
        }
      }
      this.timer = setInterval(setAngule)
    },
    updateOverall: function() {
      if (this.lastScore !== this.score && this.lastScore === null) {
        this.dasharray = '340, 20000'
        // this.timer = 1
        this.angle = 1
        this.backColor = '#F6F7FD'
        // this.fillGradient = 'white'
        this.loadingValue = 0
        if (!this.firstTime) {
          this.timer = 1
          this.changeAngule()
        } else {
          this.firstTime = false
        }
      }
      this.lastScore = this.score
    },
  },
  mounted: function() {
    this.navigatorSupport()

    this.changeAngule()
  },
}
</script>

<style lang="scss" scoped>
tspan {
  font-size: 15px;
}
</style>
